import React, { useEffect, useMemo } from 'react';
import {
  setCurrentStep,
  setFormValue,
  setNextBtnConfig,
  setPrevBtnConfig,
  useAIDiagnoseStore,
} from '../../store/useAIDiagnoseStore';
import { ActiveBgColor } from '../active-bg-color';
import { POSTURE_ADJUST_ITEM_2_TEXT } from '../posture-condition';
import { ShowTitle } from '../show-title';

import cx from './index.module.scss';

interface Props {}

export const POSTURE_CONDITION_LEVEL: Array<{
  name: string;
  level: AIDiagnose.PainLevel;
}> = [
  {
    name: '轻微',
    level: 1,
  },
  {
    name: '轻度',
    level: 2,
  },
  {
    name: '中度',
    level: 3,
  },
  {
    name: '重度',
    level: 4,
  },
  {
    name: '剧烈',
    level: 5,
  },
];

export const PostureConditionLevel: React.FC<Props> = () => {
  const { postureCondition, postureConditionLevel } = useAIDiagnoseStore.use.formValue();

  const renderBgLevel = useMemo(() => {
    if (!postureConditionLevel) return null;

    // 渲染的背景图片的等级取决于选择的最大严重等级
    return Math.max.apply(null, Object.values(postureConditionLevel)) as AIDiagnose.PainLevel;
  }, [postureConditionLevel]);

  useEffect(() => {
    setPrevBtnConfig({
      show: true,
      action: () => {
        setCurrentStep(prev => ({ currentStep: prev - 1 }));
      },
    });

    setNextBtnConfig({
      disable: postureCondition?.some(item => !postureConditionLevel?.[item]),
      action: () => {
        setCurrentStep(prev => ({ currentStep: prev + 1 }));
      },
    });
  }, [postureCondition, postureConditionLevel]);

  return (
    <div className={cx('PostureConditionLevel')}>
      <ShowTitle title="您的体态问题严重程度" subTitle="让我们更了解您的身体体态情况" />
      <div className={cx('content')}>
        <div className={cx('condition-level-wrapper')}>
          {postureCondition
            // 表单排序
            ?.sort(
              (a, b) =>
                Object.keys(POSTURE_ADJUST_ITEM_2_TEXT)?.indexOf(a) -
                Object.keys(POSTURE_ADJUST_ITEM_2_TEXT)?.indexOf(b)
            )
            ?.map(item => (
              <div key={item} className={cx('condition-level-item')}>
                <div className={cx('label')}>{POSTURE_ADJUST_ITEM_2_TEXT[item]}</div>
                <div className={cx('selector')}>
                  {POSTURE_CONDITION_LEVEL.map(item2 => (
                    <div
                      onClick={() =>
                        setFormValue(
                          {
                            postureConditionLevel: {
                              [item]: item2?.level,
                            },
                          },
                          {
                            isMerge: true,
                          }
                        )
                      }
                      className={cx('selector-item', { active: postureConditionLevel?.[item] === item2?.level })}
                      key={item2.name}
                    >
                      {item2.name}
                    </div>
                  ))}
                </div>
              </div>
            ))}
        </div>
      </div>
      <ActiveBgColor level={renderBgLevel} imgTop={-60} />
    </div>
  );
};
